import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './index.module.css';

const DEFAULT_PROMOS = [
  {
    name: 'custom',
    title: 'Featured Plates',
    description: '<p><strong>Custom plates</strong> &ndash; millions of new combos available</p>',
    image: '/images/content/featured-custom-2.png',
    imageAlt: 'Car with Custom range plate',
    href: '/browse-styles/custom',
    ctaLabel: 'Explore style',
    theme: null
  },
  {
    name: 'deluxe',
    title: 'Featured Plates',
    description: '<p>Deluxe &ndash; Timeless white plates, modern feel</p>',
    image: '/images/content/featured-deluxe-2.png',
    imageAlt: 'Deluxe White style plate',
    href: '/browse-styles/deluxe',
    ctaLabel: 'Explore style',
    theme: 'blue'
  },
  {
    name: 'love',
    title: 'Featured Plates',
    description: '<p>I Love &ndash; Show what you love on your plate</p>',
    image: '/images/content/featured-love-2.png',
    imageAlt: "Car with 'I Love' style plate",
    href: '/browse-styles/i-love',
    ctaLabel: 'Explore style',
    theme: 'orange'
  }
];

const HomePromo = ({ content, rotateInterval = 4000 }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const promos = content?.promos
    ? content.promos
        .filter((p) => p.isActive !== false)
        .map((p) => ({
          name:     p.name,
          title:    p.title,
          description: p.description ?? null,
          image:    p.imagePath    ?? p.image,
          imageAlt: p.imageAltText ?? p.imageAlt,
          href:     p.callToActionLink ?? p.href,
          ctaLabel: p.callToActionText ?? p.ctaLabel,
          css:      p.css ?? '',
        }))
    : DEFAULT_PROMOS;

  useEffect(() => {
    if (promos.length <= 1) return;
    const timer = setInterval(() => {
      setActiveIndex((i) => (i + 1) % promos.length);
    }, rotateInterval);
    return () => clearInterval(timer);
  }, [promos.length, rotateInterval]);

  return (
    <section className="home-promo">
      {promos.map((promo, index) => {
        const extraClass = promo.css || (promo.theme ? `home-promo__promo--theme-${promo.theme}` : '');
        const activeClass = index === activeIndex ? ' home-promo__promo--active' : '';
        return (
          <div
            key={promo.name}
            className={`home-promo__promo${extraClass ? ` ${extraClass}` : ''}${activeClass}`}
            data-promo-name={promo.name}
            aria-hidden={index !== activeIndex}
          >
            <h2 className="home-promo__title">{promo.title}</h2>
            {promo.description && (
              <div
                className="home-promo__description"
                dangerouslySetInnerHTML={{ __html: promo.description }}
              />
            )}
            <img
              className="home-promo__image"
              loading="lazy"
              src={promo.image}
              alt={promo.imageAlt}
            />
            <Link to={promo.href} className="home-promo__cta">
              {promo.ctaLabel}
            </Link>
          </div>
        );
      })}
    </section>
  );
};

HomePromo.propTypes = {
  content: PropTypes.shape({
    promos: PropTypes.arrayOf(PropTypes.shape({
      name:             PropTypes.string.isRequired,
      isActive:         PropTypes.bool,
      title:            PropTypes.string.isRequired,
      description:      PropTypes.string,
      imagePath:        PropTypes.string,
      imageAltText:     PropTypes.string,
      callToActionText: PropTypes.string,
      callToActionLink: PropTypes.string,
      css:              PropTypes.string,
    })),
  }),
  rotateInterval: PropTypes.number,
};

export default HomePromo;
